import { env } from "configs/EnvironmentConfig";
import { AGREEMENT_ADJUST_PARTY } from "constants/AgreementReportConstant";
import { ALL_BU } from "constants/DashboardContanst";
import { TYPE_CLONE } from "constants/IssueInvoiceConstant";
import { BU_STORE_HEADER } from "store/auth/login/actionTypes";
import fetch from "../auth/FetchInterceptor";

const IssueInvoiceService = {};

// List Issue Invoice
IssueInvoiceService.listIssueInvoice = ({ params }, bu_code, bu_parent) => {
  const columnFilter = params.columnFilter || {};

  return fetch({
    url: `${env.API_MSP}/invoices`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-checker_date",
      keywords: params.keywords || undefined,
      expand: params.expand || "maker",
      "filter[record_status]": "O",
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
      //   expand: "checker,maker," + (params.expand || ""),
    },
  });
};

// Detail HDDT
IssueInvoiceService.detailIssueInvoice = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoices/${id}`,
    method: "get",
    params: {
      expand: "invoiceDetails",
    },
  });
};
// Detail HDDT
IssueInvoiceService.cloneEnvoice = function (id, approveStatus) {
  return fetch({
    url: `${env.API_MSP}/invoices/clone/${id}`,
    method: "post",
    data: {
      approve_status: approveStatus,
    },
  });
};

// Detail HDDT
IssueInvoiceService.cloneInvoiceWarehouses = function (id, approveStatus) {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/clone/${id}`,
    method: "post",
    data: {
      approve_status: approveStatus,
    },
  });
};

// Detail HDDT
IssueInvoiceService.cloneWarehousesAgency = function (id, approveStatus) {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/clone/${id}`,
    method: "post",
    data: {
      approve_status: approveStatus,
    },
  });
};

// Detail tem vé
IssueInvoiceService.detailInvoiceTickets = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/${id}`,
    method: "get",
    params: {
      expand: "invoiceDetails",
    },
  });
};

// Detail phiếu xuất kho
IssueInvoiceService.detailDeliveryBill = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/${id}`,
    method: "get",
    params: {
      expand: "invoiceDetails",
    },
  });
};

// Detail phiếu xuất kho gửi bán đại lý
IssueInvoiceService.detailWarehouseAgency = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/${id}`,
    method: "get",
    params: {
      expand: "invoiceDetails",
    },
  });
};

// detail-pending-bill
IssueInvoiceService.detailPendingBill = function (data) {
  return fetch({
    url: `${env.API_MSP}/pending-bills/detail-pending-bill`,
    method: "get",
    params: {
      ...data,
    },
  });
};

// view-pending-bill
IssueInvoiceService.viewPendingBill = function (data) {
  return fetch({
    url: `${env.API_MSP}/pending-bills/view-pending-bill`,
    method: "get",
    params: {
      ...data,
    },
  });
};

// Create Issue Invoice
IssueInvoiceService.createIssueInvoice = ({ data }, bu_code) => {
  return fetch({
    url: `${env.API_MSP}/invoices`,
    method: "post",
    data: {
      ...data,
      bu_code,
    },
  });
};

// Edit Issue Invoice
IssueInvoiceService.editIssueInvoice = (data, id) => {
  return fetch({
    url: `${env.API_MSP}/invoices/${id}`,
    method: "put",
    data,
  });
};

// downloadFileXMLIssueInvoice
IssueInvoiceService.downloadFileXMLIssueInvoice = (
  resource_id,
  responseType
) => {
  return fetch({
    url: `${env.API_MSP}/invoices/download-xml/${resource_id}`,
    method: "get",
    responseType,
  });
};

// listIssueInvoiceTickets
IssueInvoiceService.listIssueInvoiceTickets = (
  { params },
  bu_code,
  bu_parent
) => {
  const columnFilter = params.columnFilter || {};
  return fetch({
    url: `${env.API_MSP}/invoice-tickets`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-checker_date",
      keywords: params.keywords || undefined,
      expand: params.expand || "",
      "filter[record_status]": "O",
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
      //   expand: "checker,maker," + (params.expand || ""),
    },
  });
};

// createIssueInvoiceTickets
IssueInvoiceService.createIssueInvoiceTickets = ({ data }, bu_code) => {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets`,
    method: "post",
    data: {
      ...data,
      bu_code,
    },
  });
};

// editIssueInvoiceTickets
IssueInvoiceService.editIssueInvoiceTickets = (data, id) => {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/${id}`,
    method: "put",
    data,
  });
};

// downloadFileXMLIssueInvoiceTickets
IssueInvoiceService.downloadFileXMLIssueInvoiceTickets = (
  resource_id,
  responseType
) => {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/download-xml/${resource_id}`,
    method: "get",
    responseType,
  });
};

// listDeliveryBill
IssueInvoiceService.listDeliveryBill = ({ params }, bu_code, bu_parent) => {
  const columnFilter = params.columnFilter || {};
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-checker_date",
      keywords: params.keywords || undefined,
      expand: params.expand || "maker",
      "filter[record_status]": "O",
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
      //   expand: "checker,maker," + (params.expand || ""),
    },
  });
};

// listWarehouseAgency
IssueInvoiceService.listWarehouseAgency = ({ params }, bu_code, bu_parent) => {
  const columnFilter = params.columnFilter || {};
  return fetch({
    url: `${env.API_MSP}/invoice-agents`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-checker_date",
      keywords: params.keywords || undefined,
      expand: params.expand || "maker",
      "filter[record_status]": "O",
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
      //   expand: "checker,maker," + (params.expand || ""),
    },
  });
};

// listPendingBills
IssueInvoiceService.listPendingBills = ({ params }, bu_code, bu_parent) => {
  const columnFilter = params.columnFilter || {};
  return fetch({
    url: `${env.API_MSP}/pending-bills`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      //   sort: "-invoice_date",
      keywords: params.keywords || undefined,
      expand: params.expand || "",
      "filter[record_status]": "O",
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
      //   expand: "checker,maker," + (params.expand || ""),
    },
  });
};

// createDeliveryBill
IssueInvoiceService.createDeliveryBill = ({ data }, bu_code) => {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses`,
    method: "post",
    data: {
      ...data,
      bu_code,
    },
  });
};

// createWarehouseAgency
IssueInvoiceService.createWarehouseAgency = ({ data }, bu_code) => {
  return fetch({
    url: `${env.API_MSP}/invoice-agents`,
    method: "post",
    data: {
      ...data,
      bu_code,
    },
  });
};

// editDeliveryBill
IssueInvoiceService.editDeliveryBill = (data, id) => {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/${id}`,
    method: "put",
    data,
  });
};

// editWarehouseAgency
IssueInvoiceService.editWarehouseAgency = (data, id) => {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/${id}`,
    method: "put",
    data,
  });
};

// downloadFileXMLDeliveryBill
IssueInvoiceService.downloadFileXMLDeliveryBill = (
  resource_id,
  responseType
) => {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/download-xml/${resource_id}`,
    method: "get",
    responseType,
  });
};

// downloadFileXMLWarehouseAgency
IssueInvoiceService.downloadFileXMLWarehouseAgency = (
  resource_id,
  responseType
) => {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/download-xml/${resource_id}`,
    method: "get",
    responseType,
  });
};

// listVats
IssueInvoiceService.listVats = function () {
  return fetch({
    url: `${env.API_MSP}/vats?filter[record_status]=O`,
    method: "get",
    params: {
      page: -1,
      fields: "tsuat,ltsuat,id",
      sort: "tsuat",
    },
  });
};

// listPaymentMethods
IssueInvoiceService.listPaymentMethods = function () {
  return fetch({
    url: `${env.API_MSP}/payment-methods?filter[record_status]=O`,
    method: "get",
    params: {
      page: -1,
      fields: "htttoan,id",
    },
  });
};

// listCurrencies
IssueInvoiceService.listCurrencies = function () {
  return fetch({
    url: `${env.API_MSP}/currencies?filter[record_status]=O`,
    method: "get",
    params: {
      page: -1,
      //   fields: "exception_content,content,status,maker_date,id",
    },
  });
};

// listBusinessUnits
IssueInvoiceService.getBusinessUnits = function () {
  const buTenant = localStorage.getItem(BU_STORE_HEADER);
  return fetch({
    url: `${env.API_MSP}/business-units`,
    method: "get",
    params: {
      page: -1,
      "filter[code]": buTenant,
      fields: "ten,mst,dchi,sdthoai,dctdtu,stknhang,tnhang,fax,website",
      "filter[record_status]": "O",
    },
  });
};

// getEnterpriseByTaxCode
IssueInvoiceService.getEnterpriseByTaxCode = function (taxCode) {
  return fetch({
    url: `${env.API_ENDPOINT_URL}services/msttdn/api/get-enterprise-by-tax-code`,
    method: "get",
    params: {
      taxCode,
    },
  });
};

// releaseIssueInvoice
IssueInvoiceService.releaseIssueInvoice = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoices/release/${id}`,
    method: "post",
    data: {
      type,
    },
  });
};

// releaseIssueInvoiceTicket
// type :0 ( Chuyển theo bảng tổng hợp dữ liệu hóa đơn điện tử.)
//       1 (  Chuyển đầy đủ nội dung từng hóa đơn)
IssueInvoiceService.releaseIssueInvoiceTicket = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/release/${id}`,
    method: "post",
    data: {
      type,
    },
  });
};

// releaseDeliveryBill
IssueInvoiceService.releaseDeliveryBill = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/release/${id}`,
    method: "post",
    data: {
      type,
    },
  });
};

// releaseWarehouseAgency
IssueInvoiceService.releaseWarehouseAgency = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/release/${id}`,
    method: "post",
    data: {
      type,
    },
  });
};

// releaseInvoiceTotal
IssueInvoiceService.releaseInvoiceTotal = function (transferData) {
  return fetch({
    url: `${env.API_MSP}/pending-bills/release`,
    method: "post",
    data: {
      ...transferData,
    },
  });
};

// transfer
IssueInvoiceService.transfer = function (data) {
  return fetch({
    url: `${env.API_MSP}/hooks/transfer`,
    method: "post",
    data,
  });
};

// generateNumberInvoice
IssueInvoiceService.generateNumberInvoice = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoices/generate-number/${id}`,
    method: "get",
  });
};

// generateNumberInvoiceWarehouses
IssueInvoiceService.generateNumberInvoiceWarehouses = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/generate-number/${id}`,
    method: "get",
  });
};

// generateNumberWarehouseAgency
IssueInvoiceService.generateNumberWarehouseAgency = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/generate-number/${id}`,
    method: "get",
  });
};

// ReplaceIssueInvoice
IssueInvoiceService.replaceIssueInvoice = function (
  root_id,
  attach_ids,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoices/replace`,
    method: "post",
    data: {
      root_id,
      attach_ids,
      gchu: "",
      invoice,
    },
  });
};

// ReplaceIssueInvoiceTickets
IssueInvoiceService.replaceIssueInvoiceTickets = function (
  root_id,
  attach_ids,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/replace`,
    method: "post",
    data: {
      root_id,
      //   attach_ids,
      gchu: "",
      invoice,
    },
  });
};

// replaceDeliveryBill
IssueInvoiceService.replaceDeliveryBill = function (
  root_id,
  attach_ids,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/replace`,
    method: "post",
    data: {
      root_id,
      //   attach_ids,
      gchu: "",
      invoice,
    },
  });
};

// replaceWarehouseAgency
IssueInvoiceService.replaceWarehouseAgency = function (
  root_id,
  attach_ids,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/replace`,
    method: "post",
    data: {
      root_id,
      //   attach_ids,
      gchu: "",
      invoice,
    },
  });
};

// Adjust IssueInvoice
IssueInvoiceService.adjustIssueInvoice = function (
  root_id,
  attach_ids,
  adjust_mod,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoices/adjust`,
    method: "post",
    data: {
      root_id,
      attach_ids,
      gchu: "",
      adjust_mod,
      invoice,
    },
  });
};

// Adjust IssueInvoiceTickets
IssueInvoiceService.adjustIssueInvoiceTickets = function (
  root_id,
  attach_ids,
  adjust_mod,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/adjust`,
    method: "post",
    data: {
      root_id,
      //   attach_ids,
      gchu: "",
      adjust_mod,
      invoice,
    },
  });
};

// Adjust DeliveryBill
IssueInvoiceService.adjustDeliveryBill = function (
  root_id,
  attach_ids,
  adjust_mod,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/adjust`,
    method: "post",
    data: {
      root_id,
      //   attach_ids,
      gchu: "",
      adjust_mod,
      invoice,
    },
  });
};

// adjustWarehouseAgency
IssueInvoiceService.adjustWarehouseAgency = function (
  root_id,
  attach_ids,
  adjust_mod,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/adjust`,
    method: "post",
    data: {
      root_id,
      //   attach_ids,
      gchu: "",
      adjust_mod,
      invoice,
    },
  });
};

// reviewPdfInvoice
IssueInvoiceService.reviewPdfInvoice = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoices/review-pdf/${id}`,
    method: "get",
  });
};

// return-goods
IssueInvoiceService.pdfReturnGoods = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoices/return-goods/${id}`,
    method: "get",
  });
};

// pdfConvert
IssueInvoiceService.pdfConvert = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoices/review-convert-pdf/${id}`,
    method: "get",
  });
};

// pdfCopy
IssueInvoiceService.pdfNoneCopy = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoices/review-non-copy-pdf/${id}`,
    method: "get",
  });
};

// getReportWord
IssueInvoiceService.getReportWord = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoices/report-word/${id}`,
    method: "get",
    responseType: "blob",
    params: {
      type,
    },
  });
};

// reviewPdfInvoiceTickets
IssueInvoiceService.reviewPdfInvoiceTickets = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/review-pdf/${id}`,
    method: "get",
  });
};

// deleteInvoice
IssueInvoiceService.deleteInvoice = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoices/${id}`,
    method: "delete",
  });
};

// deleteInvoiceTickets
IssueInvoiceService.deleteInvoiceTickets = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/${id}`,
    method: "delete",
  });
};

// deleteDeliveryBill
IssueInvoiceService.deleteDeliveryBill = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/${id}`,
    method: "delete",
  });
};

// deleteWarehouseAgency
IssueInvoiceService.deleteWarehouseAgency = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/${id}`,
    method: "delete",
  });
};

// cancel Invoice
IssueInvoiceService.cancelInvoice = function (
  type,
  listInvoice,
  attach_ids,
  bu_code
) {
  return fetch({
    url: `${env.API_MSP}/invoices/cancel`,
    method: "post",
    params: {
      type,
    },
    data: {
      bu_code,
      loai: 1, // Default
      dshdon: listInvoice.map(item => {
        return {
          id: item.id,
          ladhddt: 1, // Default
          tctbao: 1, // Default
          ldo: item.ldo,
        };
      }),
      attach_ids,
    },
  });
};

// cancel InvoiceTickets
IssueInvoiceService.cancelInvoiceTickets = function (
  type,
  listInvoice,
  attach_ids,
  bu_code
) {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/cancel`,
    method: "post",
    params: {
      type,
    },
    data: {
      bu_code,
      loai: 1, // Default
      dshdon: listInvoice.map(item => {
        return {
          id: item.id,
          ladhddt: 1, // Default
          tctbao: 1, // Default
          ldo: item.ldo,
        };
      }),
      //   attach_ids,
    },
  });
};

// cancelDeliveryBill
IssueInvoiceService.cancelDeliveryBill = function (
  type,
  listInvoice,
  attach_ids,
  bu_code
) {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/cancel`,
    method: "post",
    params: {
      type,
    },
    data: {
      bu_code,
      loai: 1, // Default
      dshdon: listInvoice.map(item => {
        return {
          id: item.id,
          ladhddt: 1, // Default
          tctbao: 1, // Default
          ldo: item.ldo,
        };
      }),
      //   attach_ids,
    },
  });
};

// cancelWarehouseAgency
IssueInvoiceService.cancelWarehouseAgency = function (
  type,
  listInvoice,
  attach_ids,
  bu_code
) {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/cancel`,
    method: "post",
    params: {
      type,
    },
    data: {
      bu_code,
      loai: 1, // Default
      dshdon: listInvoice.map(item => {
        return {
          id: item.id,
          ladhddt: 1, // Default
          tctbao: 1, // Default
          ldo: item.ldo,
        };
      }),
      //   attach_ids,
    },
  });
};

// sendMailInvoice
IssueInvoiceService.sendMailInvoice = function (id, listEmail) {
  return fetch({
    url: `${env.API_MSP}/mails/push`,
    method: "post",
    data: {
      invoice_id: id,
      to_mail: listEmail,
    },
  });
};

// sendMailInvoiceError
IssueInvoiceService.sendMailInvoiceError = function (id, listEmail) {
  return fetch({
    url: `${env.API_MSP}/mails/push-invoice-error`,
    method: "post",
    data: {
      invoice_error_id: id, //Id thông báo
      to_mail: listEmail,
    },
  });
};

// uploadFile
IssueInvoiceService.uploadFile = ({ file, type, isGlobal }) => {
  let url = "invoices/update-file";
  if (isGlobal) {
    url = "resource-global/upload-file";
  }
  return fetch({
    url: `${env.API_MSP}/${url}`,
    method: "post",
    data: file,
  });
};

// actionWorkflowInvoice
IssueInvoiceService.actionWorkflowInvoice = function (
  id,
  action,
  note = undefined,
  patch = "invoices"
) {
  let url = `${patch}/workflow/${id}/${action}`;
  if (patch === "tax-deduct-details" && action === "release") {
    url = `${patch}/release/${id}`;
  }
  return fetch({
    url: `${env.API_MSP}/${url}`,
    method: "post",
    data: {
      note,
    },
  });
};

// CreateIssueInvoiceEnterprise
// Tạo hóa đơn cho doanh nghiệp
IssueInvoiceService.createIssueInvoiceEnterprise = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoices/clone/${id}/${type}`, // 1 (cùng tháng),3 (khác tháng)
    method: "post",
  });
};

// createIssueInvoiceEnterpriseAdjustAll
// Tạo hóa đơn điều chỉnh giảm 100%
IssueInvoiceService.createIssueInvoiceEnterpriseAdjustAll = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoices/clone/${id}/${TYPE_CLONE.ADJUST_DECREMENT_100}`,
    method: "post",
  });
};

// uploadFileInvoice
IssueInvoiceService.uploadFileInvoice = function (root_id, attach_ids) {
  return fetch({
    url: `${env.API_MSP}/resource-global/attach`,
    method: "post",
    data: {
      root_id,
      attach_ids,
      type: 1,
    },
  });
};

// exportInvoice
IssueInvoiceService.exportInvoice = function (
  data,
  path,
  bu_code,
  bu_parent,
  invoiceReportType
) {
  const responseType = !path.includes("console") ? "blob" : undefined;
  return fetch({
    timeout: 3 * 60 * 1000,
    url: `${env.API_MSP}/${path}`, //export-console or export
    method: "get",
    responseType: responseType,
    params: {
      "filter[record_status]": "O",
      ...data,
      invoice_report_type: invoiceReportType,
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
    },
  });
};

// exportInvoiceTicket
IssueInvoiceService.exportInvoiceTicket = function (data, bu_code, bu_parent) {
  return fetch({
    timeout: 3 * 60 * 1000,
    url: `${env.API_MSP}/invoice-tickets/export`,
    method: "get",
    responseType: "blob",
    params: {
      "filter[record_status]": "O",
      ...data,
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
    },
  });
};

// exportInvoiceWarehouse
IssueInvoiceService.exportInvoiceWarehouse = function (
  data,
  bu_code,
  bu_parent
) {
  return fetch({
    timeout: 3 * 60 * 1000,
    url: `${env.API_MSP}/invoice-warehouses/export`,
    method: "get",
    responseType: "blob",
    params: {
      "filter[record_status]": "O",
      ...data,
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
    },
  });
};

// exportInvoiceWarehouseAgency
IssueInvoiceService.exportInvoiceWarehouseAgency = function (
  data,
  bu_code,
  bu_parent
) {
  return fetch({
    timeout: 3 * 60 * 1000,
    url: `${env.API_MSP}/invoice-agents/export`,
    method: "get",
    responseType: "blob",
    params: {
      "filter[record_status]": "O",
      ...data,
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
    },
  });
};

IssueInvoiceService.invoiceCampaignList = function (
  page,
  perPage,
  columnFilter,
  keywords,
  sort,
  bu_parent,
  bu_code
) {
  return fetch({
    url: `${env.API_MSP}/campaigns`,
    method: "get",
    params: {
      page,
      "per-page": perPage,
      sort: sort,
      //   expand: "maker,checker",
      //   fields:
      //     "process_code,file_name,status,id,maker_id,maker_date,checker_id,checker_date,record_status,auth_status,content",
      ...columnFilter,
      keywords: keywords ? keywords : undefined,
      "filter[store_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
    },
  });
};

// uploadCampaignInvoice
IssueInvoiceService.uploadCampaignInvoice = function (
  type,
  report_id,
  store_code
) {
  return fetch({
    url: `${env.API_MSP}/campaigns`,
    method: "post",
    data: {
      type,
      report_id,
      store_code,
    },
  });
};

// Detail lô hóa đơn
IssueInvoiceService.campaignInvoiceDetail = function (id) {
  return fetch({
    url: `${env.API_MSP}/campaigns/${id}`,
    method: "get",
  });
};

// releaseCampaignInvoice
IssueInvoiceService.releaseCampaignInvoice = function (id) {
  return fetch({
    url: `${env.API_MSP}/campaigns/release/${id}`,
    method: "post",
  });
};

// checkInvoiceStatus
IssueInvoiceService.checkInvoiceStatus = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoices/check-invoice-status/${id}`,
    method: "get",
  });
};

//
IssueInvoiceService.getDataLink = function (id, isGetChild) {
  return fetch({
    url: `${env.API_MSP}/links/${isGetChild ? "child" : "root"}/${id}`,
    method: "get",
  });
};

//
IssueInvoiceService.getAdjustLimit = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoices/adjust-limit/${id}`,
    method: "get",
  });
};

// replaceIssueInvoiceTT32
IssueInvoiceService.replaceIssueInvoiceTT32 = function (attach_ids, invoice) {
  return fetch({
    url: `${env.API_MSP}/invoices/replace32`,
    method: "post",
    data: {
      attach_ids,
      invoice,
    },
  });
};

// adjustIssueInvoiceTT32
IssueInvoiceService.adjustIssueInvoiceTT32 = function (
  attach_ids,
  adjust_mod,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoices/adjust32`,
    method: "post",
    data: {
      attach_ids,
      adjust_mod,
      invoice,
    },
  });
};

// invoiceMaxDate
// Ngày của hóa đơn phát hành gần nhất
IssueInvoiceService.invoiceMaxDate = function (khmhdon, khhdon, bu_code) {
  return fetch({
    url: `${env.API_MSP}/invoices/max-date`,
    method: "get",
    params: {
      khmhdon,
      khhdon,
      bu_code,
    },
  });
};

// invoiceMinDate
// Ngày của hóa đơn lưu tạm xa nhất
IssueInvoiceService.invoiceMinDate = function (khmhdon, khhdon, bu_code) {
  return fetch({
    url: `${env.API_MSP}/invoices/min-date`,
    method: "get",
    params: {
      khmhdon,
      khhdon,
      bu_code,
    },
  });
};

// downloadZip
IssueInvoiceService.downloadZip = function (ids, type, bu_code) {
  return fetch({
    url: `${env.API_MSP}/invoices/zip`,
    method: "post",
    data: {
      ids,
      type,
      bu_code,
    },
  });
};

// listInvoiceTCTError
IssueInvoiceService.listInvoiceTCTError = ({ params }, bu_code, bu_parent) => {
  const columnFilter = { ...params.columnFilter } || {};
  return fetch({
    url: `${env.API_MSP}/invoices`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: "-checker_date",
      keywords: params.keywords || undefined,
      // expand: params.expand || "",
      "filter[is_problem]": 1,
      //   "filter[auth_status][!=]": AUTH_STATUS_APPROVE,
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
      expand: "maker",
      //   expand: "checker,maker," + (params.expand || ""),
    },
  });
};

// listDeliveryBillTCTError
IssueInvoiceService.listDeliveryBillTCTError = (
  { params },
  bu_code,
  bu_parent
) => {
  const columnFilter = { ...params.columnFilter } || {};
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: "-checker_date",
      keywords: params.keywords || undefined,
      "filter[is_problem]": 1,
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
      expand: "maker",
    },
  });
};

// listWareHouseAgencyTCTError
IssueInvoiceService.listWareHouseAgencyTCTError = (
  { params },
  bu_code,
  bu_parent
) => {
  const columnFilter = { ...params.columnFilter } || {};
  return fetch({
    url: `${env.API_MSP}/invoice-agents`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: "-checker_date",
      keywords: params.keywords || undefined,
      // expand: params.expand || "",
      "filter[is_problem]": 1,
      //   "filter[auth_status][!=]": AUTH_STATUS_APPROVE,
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
      expand: "maker",
      //   expand: "checker,maker," + (params.expand || ""),
    },
  });
};

// listInvoiceRecently
IssueInvoiceService.listInvoiceRecently = ({ params }, bu_code, bu_parent) => {
  const columnFilter = { ...params.columnFilter } || {};
  return fetch({
    url: `${env.API_MSP}/dashboards/invoice-recently`,
    method: "get",
    params: {
      // ...columnFilter,
      // page: params.page || 1,
      // "per-page": params.sizePerPage || 10,
      // sort: "-checker_date",
      // keywords: params.keywords || undefined,
      // // expand: params.expand || "",
      // "filter[is_problem]": 1,
      // //   "filter[auth_status][!=]": AUTH_STATUS_APPROVE,
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
    },
  });
};

// deleteResourceGlobal
IssueInvoiceService.deleteResourceGlobal = id => {
  return fetch({
    url: `${env.API_MSP}/resource-global/delete/${id}`,
    method: "delete",
  });
};

//
//configurations
IssueInvoiceService.configInvoice = ({ queryKey }) => {
  const buCode = queryKey[1];
  return fetch({
    url: `${env.API_MSP}/configurations`,
    method: "get",
    params: {
      "filter[bu_code]": buCode !== ALL_BU ? buCode : undefined,
      "filter[record_status]": "O",
    },
  });
};

//getCurrentTime
IssueInvoiceService.getCurrentTime = () => {
  return fetch({
    url: `${env.API_MSP}/internal/current-time`,
    method: "get",
  });
};

// pdfTaxDeduct
IssueInvoiceService.pdfTaxDeduct = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/tax-deduct-details/review-pdf/${id}`,
    method: "get",
  });
};

// pdfTaxDeductRegistry
IssueInvoiceService.pdfTaxDeductRegistry = function (id, path) {
  return fetch({
    url: `${env.API_MSP}/registry-tax-deducts/${path}/${id}`,
    method: "get",
  });
};

// uploadTaxDeduct
IssueInvoiceService.uploadTaxDeduct = function (type, resource_id, bu_code) {
  return fetch({
    url: `${env.API_MSP}/tax-deduct-reports`,
    method: "post",
    data: {
      type,
      resource_id,
      bu_code,
    },
  });
};

// createTaxDeductReport
IssueInvoiceService.createTaxDeductReport = function (
  dataFilter,
  parameters,
  bu_code
) {
  return fetch({
    url: `${env.API_MSP}/tax-deduct-reports`,
    method: "post",
    data: {
      parameters: parameters,
      bu_code,
      type: 2,
      ...dataFilter,
    },
  });
};

// releaseTaxDeduct
IssueInvoiceService.releaseTaxDeduct = function (id, patch) {
  return fetch({
    url: `${env.API_MSP}/${patch}/release/${id}`,
    method: "post",
  });
};

// sendMailTaxDeduct
IssueInvoiceService.sendMailTaxDeduct = function (id, listEmail) {
  return fetch({
    url: `${env.API_MSP}/tax-deduct-details/send-mail/${id}`,
    method: "post",
    data: {
      to_email: listEmail,
    },
  });
};

// Lấy dữ liệu biên bản thỏa thuận. Có agreement_id thì lấy đúng bản đã lưu đó;
// không có thì BE trả dữ liệu mặc định theo hóa đơn gốc để lập bản mới.
IssueInvoiceService.getAgreementInfo = function ({ id, type, agreement_id }) {
  return fetch({
    url: `${env.API_MSP}/invoices/agreement-info/${id}`,
    method: "get",
    params: {
      type,
      agreement_id: agreement_id || undefined,
    },
  });
};

// Lưu biên bản thỏa thuận
IssueInvoiceService.saveAgreementInfo = function ({ invoice_id, type, data }) {
  return fetch({
    url: `${env.API_MSP}/invoices/agreement-save`,
    method: "post",
    data: {
      invoice_id: invoice_id,
      type,
      // null = tạo bản mới, có id = cập nhật đúng bản đó
      agreement_id: data.agreement_id || null,
      // code: data?.code,
      // report_date: data?.report_date,
      reason: data?.reason,
      // Biên bản trả hàng: id các dòng GIỮ LẠI. Thiếu field này BE vẫn lưu đủ
      // dòng cũ nên PDF và lần mở lại vẫn còn dòng vừa xóa. Loại biên bản khác
      // không có dòng hàng, để undefined thì JSON không gửi field này.
      item_ids: data?.item_ids?.length ? data.item_ids : undefined,
      // Biên bản trả hàng: số lượng trả từng dòng [{id, quantity}], dòng không
      // gửi thì BE hiểu là trả đủ. Loại khác không có -> undefined.
      items: data?.item_ids?.length ? data.items : undefined,
      // Biên bản điều chỉnh thông tin: đang sửa thông tin của bên nào
      // ("buyer" / "seller"). Thiếu field này BE không biết lấy khối nào để
      // dựng PDF. Loại biên bản khác không có field -> undefined, JSON bỏ qua.
      adjust_party: data?.adjust_party,
      // Thông tin bên bán (seller.company / seller.unit) chỉ có nghĩa khi
      // đang điều chỉnh bên bán. Lúc điều chỉnh bên mua thì khối after rỗng,
      // gửi lên dễ làm BE ghi đè mất dữ liệu cũ.
      seller:
        data?.adjust_party === AGREEMENT_ADJUST_PARTY.SELLER
          ? data?.seller
          : undefined,
      // party_a và amounts có cấu trúc { before, after }, gửi nguyên khối
      party_a: data?.party_a,
      // party_a: {
      //   before: {
      //     name: data?.party_a?.before?.name,
      //     tax_code: data?.party_a?.before?.tax_code,
      //     address: data?.party_a?.before?.address,
      //     email: data?.party_a?.before?.email,
      //     phone: data?.party_a?.before?.phone,
      //     full_name: data?.party_a?.before?.full_name,
      //     customer_code: data?.party_a?.before?.customer_code,
      //     bank_account: data?.party_a?.before?.bank_account,
      //     bank_name: data?.party_a?.before?.bank_name,
      //     representative: data?.party_a?.before?.representative,
      //     position: data?.party_a?.before?.position,
      //   },
      //   after: {
      //     name: data?.party_a?.before?.name,
      //     tax_code: data?.party_a?.before?.tax_code,
      //     address: data?.party_a?.before?.address,
      //     email: data?.party_a?.before?.email,
      //     phone: data?.party_a?.before?.phone,
      //     full_name: data?.party_a?.before?.full_name,
      //     customer_code: data?.party_a?.before?.customer_code,
      //     bank_account: data?.party_a?.before?.bank_account,
      //     bank_name: data?.party_a?.before?.bank_name,
      //     representative: data?.party_a?.before?.representative,
      //     position: data?.party_a?.before?.position,
      //   },
      // },
      amounts: data?.amounts,
      // Vùng ký trên PDF, giữ nguyên shape sign_zones của hệ e-sign
      sign_zones: data?.sign_zones,
      party_b: {
        name: data?.party_b?.name,
        tax_code: data?.party_b?.tax_code,
        address: data?.party_b?.address,
        representative: data?.party_b?.representative,
        position: data?.party_b?.position,
      },
    },
  });
};

// Tính lại số tiền biên bản trả hàng theo các dòng hàng giữ lại (không lưu).
// item_ids = id các dòng GIỮ LẠI, items = số lượng trả [{id, quantity}], cùng
// nghĩa với agreement-save. Response trả thêm thành tiền từng dòng (data.items).
IssueInvoiceService.previewAgreementGra = function ({
  invoice_id,
  item_ids,
  items,
}) {
  return fetch({
    url: `${env.API_MSP}/invoices/agreement-gra-preview`,
    method: "post",
    data: {
      invoice_id,
      item_ids,
      items,
    },
  });
};

// Tải file PDF của biên bản thỏa thuận đã lưu
IssueInvoiceService.downloadAgreement = function ({ agreement_id }) {
  return fetch({
    url: `${env.API_MSP}/invoices/agreement-download/${agreement_id}`,
    method: "get",
    responseType: "blob",
  });
};

// Danh sách biên bản thỏa thuận đã lập của một hóa đơn.
// sign_status: draft | partial | signed, nhiều giá trị cách dấu phẩy; bỏ trống = tất cả
IssueInvoiceService.getAgreementList = function ({ id, sign_status }) {
  return fetch({
    url: `${env.API_MSP}/invoices/agreement-list/${id}`,
    method: "get",
    params: {
      sign_status: sign_status || undefined,
    },
  });
};

// Upload file biên bản đã ký giấy (file là FormData)
IssueInvoiceService.uploadAgreementFile = function ({ file }) {
  return fetch({
    url: `${env.API_MSP}/invoices/update-file`,
    method: "post",
    data: file,
  });
};

// Gắn file đã ký giấy vào biên bản thỏa thuận
IssueInvoiceService.attachAgreement = function ({
  invoice_id,
  resource_id,
  agreement_id,
}) {
  return fetch({
    url: `${env.API_MSP}/invoices/agreement-attach`,
    method: "post",
    data: {
      invoice_id,
      resource_id,
      agreement_id,
    },
  });
};

// ── Ký số biên bản thỏa thuận ───────────────────────────────────────────────
// Ba API dưới đây trước nay chưa có FE nào gọi, phải chạy tay bằng curl/Postman.

// Bên B (công ty) ký số vào biên bản. Bất đồng bộ: đẩy job sang mssigning rồi
// trả ngay, phải poll getAgreementSignInfo để biết đã ký xong chưa.
IssueInvoiceService.signAgreement = function ({ agreement_id }) {
  return fetch({
    url: `${env.API_MSP}/invoices/agreement-sign`,
    method: "post",
    data: {
      agreement_id,
    },
  });
};

// Trạng thái ký của cả hai bên + link PDF hiện tại.
IssueInvoiceService.getAgreementSignInfo = function ({ agreement_id }) {
  return fetch({
    url: `${env.API_MSP}/invoices/agreement-sign-info/${agreement_id}`,
    method: "get",
  });
};

// Tạo phiên ký trên cổng ký rồi gửi mail link cho bên mua.
// execute=true để gửi đồng bộ, biết kết quả ngay thay vì đẩy vào queue notify.
IssueInvoiceService.sendAgreementSignMail = function ({
  agreement_id,
  to_mail,
}) {
  return fetch({
    url: `${env.API_MSP}/invoices/agreement-send-mail`,
    method: "post",
    data: {
      agreement_id,
      to_mail,
      execute: true,
    },
  });
};

export default IssueInvoiceService;
